import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  root: {
    display: "inline-flex",
    color: "#5A5B62",
    fontSize: "12px",
    alignItems: "center",
    marginRight: "5px",
  },

  label: {
    color: "#5A5B62",
    background: "#F4F6F9",
    padding: "1px 3px",
    marginRight: "5px",
  },
});

/**
 * 作成者ラベル
 */
class OwnerShipLabel extends React.PureComponent {
  render = () => {
    const { classes, name } = this.props;
    return (
      <div className={classes.root}>
        <span className={classes.label}>作成者</span>
        {name}
      </div>
    );
  }
}

OwnerShipLabel.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
};

export default withStyles(styles)(OwnerShipLabel);



// WEBPACK FOOTER //
// ./src/components/common/OwnerShip/OwnerShipLabel.jsx